var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"pie","label":_vm.label,"height":400,"options":_vm.pieChart.chartOptions,"series":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }